import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import useFeatureFlagsStore from '@/store/FeatureFlagsStore';
import type { Branch } from '../../utils/Branch';
import AppointmentTypeSelection from '../AppointmentTypeSelection';

interface AppointmentTypeModuleProps {
  branchSearchTerm: string;
  setBranchSearchTerm: (term: string) => void;
  branchesData?: Branch[];
  isLoading?: boolean;
  zipCodeError?: string;
}

const AppointmentTypeModule: React.FC<AppointmentTypeModuleProps> = ({
  branchSearchTerm,
  setBranchSearchTerm,
  branchesData,
  isLoading = false,
  zipCodeError,
}) => {
  const featureFlags = useFeatureFlagsStore((state) => state.featureFlags);

  const location = useLocation();

  const isRescheduleAppointment = useMemo(
    () => location.pathname.includes('reschedule-appointment'),
    [location.pathname],
  );

  if (isRescheduleAppointment || !featureFlags.inBranchAppointments) {
    return null;
  }

  return (
    <AppointmentTypeSelection
      branchesData={branchesData}
      branchSearchTerm={branchSearchTerm}
      setBranchSearchTerm={setBranchSearchTerm}
      isLoading={isLoading}
      zipCodeError={zipCodeError}
    />
  );
};

export default AppointmentTypeModule;
